import Pagination from "../../../components/Pagination";

export default function DashboardModal({
  styles,
  modalStyles,
  activeModal,
  closeModal,
  roleId,
  userBranchCode,
  branchListError,
  fullTempRows,
  tempRowsPage,
  getTempClass,
  safeTempPage,
  tempPageCount,
  onTempPageChange,
  TEMP_PAGE_SIZE,
  branchesError,
  branchListError2,
  branchList,
  branchesRowsPage,
  safeBranchesPage,
  branchesPageCount,
  onBranchesPageChange,
  BRANCHES_PAGE_SIZE,
  totalLowDisplay,
  criticalLowDisplay,
  lowBranchNames,
  lowKpiError,
  totalExpiredDisplay,
  nearingExpiryDisplay,
  expiredBranchesDisplay,
  expiredKpiError,
}) {
  if (!activeModal) return null;

  return (
    <div className={modalStyles.modalPopup} onClick={closeModal}>
      <div
        className={`${modalStyles.modalContent} ${styles.dashboardModalContent} ${activeModal === "temp" ? styles.dashboardModalContentCompact : ""} ${activeModal === "branches" ? styles.dashboardModalContentMedium : ""}`}
        style={
          activeModal === "branches"
            ? {
                width: "min(85vw, 520px)",
                maxWidth: "520px",
              }
            : undefined
        }
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          className={`${modalStyles.closeBtn} ${styles.dashboardCloseBtn}`}
          onClick={closeModal}
          aria-label="Close"
        >
          ×
        </button>
        <div
          className={`${styles.dashboardModalCard} ${activeModal === "temp" ? styles.dashboardModalCardCompact : ""} ${activeModal === "branches" ? styles.dashboardModalCardMedium : ""}`}
          style={
            activeModal === "branches"
              ? {
                  width: "100%",
                  maxWidth: "520px",
                }
              : undefined
          }
        >
          {activeModal === "temp" && (
            <>
              <div className={styles.dashboardModalHeader}>
                <h2 className={styles.dashboardModalTitle}>Temperature Monitoring</h2>
              </div>

              {branchListError && (
                <p className="text-red-500 text-xs mt-1">{branchListError}</p>
              )}

              {roleId !== 2 && !userBranchCode && (
                <p className="text-red-500 text-xs mt-1">No branch assigned to your user</p>
              )}

              <ul className={styles.tempList}>
                {fullTempRows.length === 0 ? (
                  <li className={styles.tempEmpty}>No temperature data</li>
                ) : (
                  tempRowsPage.map((row) => (
                    <li
                      key={row.branchcode || row.branchname}
                      className={styles.tempItem}
                      title={row.branchcode ? `Branch code: ${row.branchcode}` : undefined}
                    >
                      <span className={getTempClass(row.status)}>{row.temp}°C</span>
                      <span className={styles.tempBranchName}>{row.branchname}</span>
                    </li>
                  ))
                )}
              </ul>

              {roleId === 2 && fullTempRows.length > TEMP_PAGE_SIZE && (
                <div className={styles.paginationRow}>
                  <Pagination
                    currentPage={safeTempPage}
                    totalPages={tempPageCount}
                    onPageChange={onTempPageChange}
                  />
                </div>
              )}
            </>
          )}

          {activeModal === "branches" && (
            <>
              <div className={styles.dashboardModalHeader}>
                <div className={styles.dashboardModalTitleRow}>
                  <h2 className={styles.dashboardModalTitle}>Branches</h2>
                  {branchList.length > 0 && (
                    <span className={styles.cardHintBadge}>{branchList.length} total</span>
                  )}
                </div>
              </div>

              {branchesError && (
                <p className="text-red-500 text-xs mt-1">{branchesError}</p>
              )}
              {branchListError2 && (
                <p className="text-red-500 text-xs mt-1">{branchListError2}</p>
              )}

              <div className={styles.branchTable}>
                <div className={styles.branchTableHeader}>
                  <span className={styles.branchHeaderCode}>Code</span>
                  <span className={styles.branchHeaderName}>Branch</span>
                </div>

                {branchList.length === 0 ? (
                  <p className={styles.branchEmpty}>No branches to display</p>
                ) : (
                  <div className={styles.branchTableBody}>
                    {branchesRowsPage.map((b) => (
                      <div key={b.branchcode || b.branchname} className={styles.branchRow}>
                        <span className={styles.branchCodeCell} title={b.branchcode}>
                          {b.branchcode || "--"}
                        </span>
                        <span className={styles.branchNameCell} title={b.branchname}>
                          {b.branchname}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {branchList.length > BRANCHES_PAGE_SIZE && (
                <div className={styles.paginationRow}>
                  <Pagination
                    currentPage={safeBranchesPage}
                    totalPages={branchesPageCount}
                    onPageChange={onBranchesPageChange}
                  />
                </div>
              )}
            </>
          )}

          {activeModal === "low" && (
            <>
              <div className={styles.dashboardModalHeader}>
                <h2 className={styles.dashboardModalTitle}>Low Stock Alerts</h2>
              </div>

              <div className={styles.modalKpiGrid}>
                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Total low stock items</div>
                  <div className={styles.modalKpiValue}>{totalLowDisplay}</div>
                </div>

                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Critical items</div>
                  <div className={styles.modalKpiValue}>{criticalLowDisplay}</div>
                </div>

                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Branches impacted</div>
                  {lowBranchNames.length === 0 ? (
                    <div className={styles.modalKpiValue}>--</div>
                  ) : (
                    <div className={styles.modalKpiPills}>
                      {lowBranchNames.map((name) => (
                        <span key={name} className={styles.branchPill} title={name}>
                          {name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {lowKpiError && <p className="text-red-500 text-xs mt-2">{lowKpiError}</p>}
            </>
          )}

          {activeModal === "expiry" && (
            <>
              <div className={styles.dashboardModalHeader}>
                <h2 className={styles.dashboardModalTitle}>Expiring Stock</h2>
              </div>

              <div className={styles.modalKpiGrid}>
                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Total expiring</div>
                  <div className={styles.modalKpiValue}>{totalExpiredDisplay}</div>
                </div>

                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Critical (&lt; 30 days)</div>
                  <div className={styles.modalKpiValue}>{nearingExpiryDisplay}</div>
                </div>

                <div className={styles.modalKpiCard}>
                  <div className={styles.modalKpiLabel}>Branches impacted</div>
                  <div className={styles.modalKpiValue}>{expiredBranchesDisplay}</div>
                </div>
              </div>

              {expiredKpiError && (
                <p className="text-red-500 text-xs mt-2">{expiredKpiError}</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
